// AUTO-GENERATED by scripts/sync-i18n.mjs — do not edit by hand.
// Source: shared/i18n/{en,fa}.json and shared/i18n/metadata/locales.json
export const localeIds = ["en","fa"] as const;
export type Locale = (typeof localeIds)[number];
export interface LocaleMetadata {
  direction: "ltr" | "rtl";
  default: boolean;
  displayName: string;
  formatLocale: string;
}
export const localeMetadata: Record<Locale, LocaleMetadata> = {
  "en": {
    "direction": "ltr",
    "default": true,
    "displayName": "English",
    "formatLocale": "en-US"
  },
  "fa": {
    "direction": "rtl",
    "default": false,
    "displayName": "فارسی",
    "formatLocale": "fa-IR"
  }
} as Record<Locale, LocaleMetadata>;
export const defaultLocale: Locale = "en";
export const en: Record<string, string> = {
  "app.name": "ONYX",
  "app.observer": "ONYX Observer",
  "app.remoteOperator": "Remote Operator",
  "app.tagline": "Mission Operations",
  "app.thinClient": "Thin client",
  "app.thinClientNote": "No offline commands or local domain state.",
  "nav.approvals": "Approvals",
  "nav.closeMenu": "Close navigation",
  "nav.dashboard": "Dashboard",
  "nav.files": "Files",
  "nav.home": "Home",
  "nav.menu": "Menu",
  "nav.messaging": "Messaging",
  "nav.missions": "Missions",
  "nav.nativeOperationalWorkspace": "Native operational workspace",
  "nav.notifications": "Notifications",
  "nav.openMenu": "Open navigation",
  "nav.organizations": "Organizations",
  "nav.overview": "Overview",
  "nav.primary": "Primary navigation",
  "nav.profiles": "Profiles",
  "nav.reports": "Reports",
  "nav.settings": "Settings",
  "nav.skipToContent": "Skip to main content",
  "nav.staffDesktop": "Staff desktop",
  "nav.staffDesktopNote": "Local replica with explicit sync state and protected commands.",
  "nav.staffLoans": "Staff Loans",
  "nav.staffOperator": "Staff operator",
  "nav.staffWorkspace": "Staff workspace",
  "nav.tasks": "Tasks",
  "nav.todos": "Todos & Targets",
  "nav.users": "Users",
  "auth.adminAccessRequired": "Admin access required",
  "auth.adminAccountForOrganization": "Use an administrator account for this organization.",
  "auth.adminConnectionSecurity": "Connection security",
  "auth.adminCredentialsDescription": "Administrators and All-Father sign in with their ONYX username and password.",
  "auth.adminHeroDescription": "Manage organization policy, access, and staff profiles from a dedicated administrative workspace.",
  "auth.adminHeroHeadline": "Govern operations with calm, visible control.",
  "auth.adminInvalidCredentials": "Invalid username or password.",
  "auth.adminOrganizationAdministration": "Organization-scoped administration · Explicit server verification",
  "auth.adminSecureAccess": "SECURE ADMIN ACCESS",
  "auth.adminSession": "Admin session",
  "auth.adminSignIn": "Sign in to ONYX",
  "auth.adminTitle": "ADMINISTRATOR",
  "auth.adminTitleBar": "ONYX Admin",
  "auth.allFatherAuthority": "ALL-FATHER AUTHORITY",
  "auth.desktopHeroBody": "Review mission work, resolve approvals, and act with an explicit local sync state.",
  "auth.desktopHeroTitle": "Operational clarity, from every authorized desktop.",
  "auth.heroBody": "Review missions, monitor critical work, acknowledge notifications, and make permitted approval decisions without installing a native replica.",
  "auth.heroTitle": "Operational clarity, from any authorized browser.",
  "auth.initialPassword": "Initial password",
  "auth.invalidCredentials": "Invalid username or password.",
  "auth.logOut": "Log out",
  "auth.nativeReplicaProtectedSession": "Native desktop replica · Server-authoritative commands · Protected session",
  "auth.password": "Password",
  "auth.productIntroduction": "ONYX product introduction",
  "auth.retryGoogleListener": "Retry callback setup",
  "auth.secureBrowserAccess": "Secure browser access",
  "auth.secureDesktopAccess": "SECURE DESKTOP ACCESS",
  "auth.sessionNote": "Expired access requires a new sign-in. Refresh rotation is intentionally disabled in v1.",
  "auth.sessionSecurity": "Session security",
  "auth.signIn": "Sign in",
  "auth.signInToOnyx": "Sign in to ONYX",
  "auth.signOut": "Sign out",
  "auth.signOutRetry": "Sign out and retry",
  "auth.signedIn": "Signed in",
  "auth.signingIn": "Signing in…",
  "auth.signingOut": "Signing out…",
  "auth.staffOperations": "Staff operations",
  "auth.staffOperator": "STAFF OPERATOR",
  "auth.test": "Test",
  "auth.testing": "Testing…",
  "auth.thinClientServerAuthoritative": "Thin client · Server-authoritative · No offline command queue",
  "auth.tokensProtectedNative": "Tokens remain in protected native storage. Reauthentication is required when the server changes.",
  "auth.useAssignedCredentials": "Use the username and password assigned to your ONYX account.",
  "auth.useOrgCredentials": "Use your organization credentials. This browser stores tokens for this session only.",
  "auth.useOrgCredentialsNative": "Use your organization credentials. Your session remains in secure native storage on this device.",
  "auth.username": "Username",
  "common.accept": "Accept",
  "common.account": "Account",
  "common.actions": "Actions",
  "common.activate": "Activate",
  "common.add": "Add",
  "common.addAnotherItem": "Add another item",
  "common.addMemberUserId": "Add member (user id)",
  "common.addRule": "Add rule",
  "common.admin": "Admin",
  "common.adminConnectionHelp": "Choose where ONYX Admin should connect. The address is saved only after a successful health check.",
  "common.adminPlatform": "Admin platform",
  "common.adminPrimaryNavigation": "Admin primary navigation",
  "common.administration": "Administration",
  "common.administrativeControlPlane": "Administrative control plane",
  "common.administrativeWorkspace": "Administrative workspace",
  "common.administrator": "Administrator",
  "common.all": "All",
  "common.allFatherAdministration": "All-Father administration",
  "common.allLoans": "All loans",
  "common.anotherComputer": "Another computer",
  "common.approvalGranted": "Approval granted.",
  "common.approvalRejected": "Approval rejected.",
  "common.approve": "Approve",
  "common.assignee": "Assignee",
  "common.assignmentQuestion": "Who is this for?",
  "common.batchImportExport": "Batch import / export",
  "common.borrowingManager": "Borrowing manager",
  "common.cancel": "Cancel",
  "common.checkingConnection": "Checking connection",
  "common.chooseBorrowingManager": "Choose the manager receiving temporary authority",
  "common.chooseLoanedStaff": "Choose the staff member being loaned",
  "common.chooseOwner": "Choose the person who will own this work",
  "common.chooseOwningManager": "Choose the staff member's owning manager",
  "common.choosePerson": "Choose a person",
  "common.class": "Class",
  "common.classLabel": "Class label",
  "common.close": "Close",
  "common.commandsNotQueued": "Commands are not queued. Reconnect, then retry the action.",
  "common.comment": "Comment",
  "common.confirmActivateOrganization": "Reactivate this organization? Existing records remain; old sessions stay revoked.",
  "common.confirmDeactivateOrganization": "Deactivate this organization? Member access will stop and their existing sessions will be revoked until reactivation.",
  "common.confirmDeactivateOrganizationAdmin": "Deactivate this organization admin? They will lose access and existing sessions will be revoked.",
  "common.confirmDecline": "Confirm decline",
  "common.confirmEscalate": "Confirm escalation",
  "common.confirmExtension": "Confirm extension",
  "common.confirmReject": "Confirm reject",
  "common.confirmVerify": "Confirm verify",
  "common.conflicts": "conflicts",
  "common.connected": "Connected",
  "common.connectionLost": "Connection lost.",
  "common.connectionSetup": "Connection setup",
  "common.connectionVerifiedBeforeSave": "Connection settings are verified before they are saved.",
  "common.connections": "Connections",
  "common.contact": "Contact",
  "common.contactEmail": "Contact email",
  "common.contactPhone": "Contact phone",
  "common.create": "Create",
  "common.createConversation": "Create conversation",
  "common.createOrganization": "Create organization",
  "common.createOrganizationAdmin": "Create organization admin",
  "common.createPolicy": "Create policy",
  "common.createTarget": "Create a target",
  "common.createTodoList": "Create a todo list",
  "common.createUser": "Create user",
  "common.creating": "Creating…",
  "common.deactivate": "Deactivate",
  "common.decisionEscalatedToYou": "This verification decision was escalated to you.",
  "common.decline": "Decline",
  "common.declineReasonRequired": "Reason for declining (required)",
  "common.department": "Department",
  "common.description": "Description",
  "common.disable": "Disable",
  "common.disabling": "Disabling…",
  "common.disconnected": "Disconnected",
  "common.download": "Download",
  "common.downloading": "Downloading…",
  "common.draftNewVersion": "Draft a new version",
  "common.due": "Due",
  "common.edit": "Edit",
  "common.editProfile": "Edit profile",
  "common.enabling": "Enabling…",
  "common.endEarly": "End early",
  "common.english": "English",
  "common.escalate": "Escalate",
  "common.escalateList": "Escalate list",
  "common.escalated": "Escalated.",
  "common.evaluate": "Evaluate",
  "common.exportCsv": "Export CSV",
  "common.exportJson": "Export JSON",
  "common.extend": "Extend",
  "common.farsi": "فارسی",
  "common.firstItemExample": "First item, e.g. Write the weekly report",
  "common.fullName": "Full name",
  "common.grantAdministratorAccess": "Grant administrator access",
  "common.id16Placeholder": "[12,34,...]",
  "common.identityManagement": "IDENTITY MANAGEMENT",
  "common.importing": "Importing…",
  "common.inactive": "Inactive",
  "common.inputValue": "value",
  "common.involvingMe": "Involving me",
  "common.itemAdded": "Item added.",
  "common.items": "Items",
  "common.itemsCount": "{count} items",
  "common.jobTitle": "Job title",
  "common.keyExample": "key, e.g. messaging.enabled",
  "common.language": "Language",
  "common.legalHolds": "Legal holds",
  "common.listKind": "List kind",
  "common.loading": "Loading…",
  "common.loadingAdmin": "Loading ONYX Admin…",
  "common.loadingOnyx": "Loading ONYX…",
  "common.loadingPeople": "Loading people…",
  "common.loadingSecureSession": "Loading secure session…",
  "common.loanEnds": "Loan ends",
  "common.loanStarts": "Loan starts",
  "common.loans": "Loans",
  "common.lookup": "Look up",
  "common.lookupByConversationId": "Look up by conversation id (JSON array of 16 bytes)",
  "common.manageAdmins": "Manage admins",
  "common.managerAssigned": "Manager-assigned",
  "common.messageTextPlaceholder": "Message text",
  "common.mobileAccess": "Mobile access",
  "common.name": "Name",
  "common.newAccount": "New account",
  "common.newAccountDescription": "New accounts receive only the classification and administrator access selected here.",
  "common.newEndDateTime": "New end date/time",
  "common.newProfile": "New profile",
  "common.newTextPlaceholder": "New text",
  "common.noActionsAvailable": "No actions available at this status.",
  "common.noClass": "No class",
  "common.noConversationFoundForId": "No conversation found for this id.",
  "common.noData": "No data available.",
  "common.noItems": "No items.",
  "common.noLoanApprovalsEscalated": "No loan approvals have been escalated to you.",
  "common.noLoansInvolvingYou": "No loans involve you yet.",
  "common.noLoansYetRequestOne": "No loans yet. Request one above.",
  "common.noOrganizationAdminsYet": "No administrators are provisioned for this organization.",
  "common.noOrganizationsYet": "No organizations are provisioned yet.",
  "common.noParent": "No parent",
  "common.noPeopleMatch": "No people match this search.",
  "common.noPolicyFound": "No policy found for this id.",
  "common.noProfilesYet": "No profiles yet.",
  "common.noSelection": "Select an item to see details.",
  "common.noVersionsYet": "No versions yet.",
  "common.notificationAcknowledged": "Notification acknowledged.",
  "common.observerProjectionNotFound": "This projection view is not part of the observer client surface.",
  "common.offline": "Offline",
  "common.offlineSnapshot": "You're offline — showing the last snapshot.",
  "common.online": "Online",
  "common.onlyOwnerCanSubmit": "Only the owner can submit this list.",
  "common.open": "Open",
  "common.operationalClass": "Operational class",
  "common.organization": "Organization",
  "common.organizationAdmins": "Organization administrators",
  "common.organizationInactive": "This organization is inactive. Admin accounts cannot sign in until it is reactivated.",
  "common.organizationManagementDescription": "Create organizations and manage their organization-admin accounts. Deactivation suspends access without deleting records.",
  "common.organizationName": "Organization name",
  "common.organizations": "Organizations",
  "common.origin": "Origin",
  "common.outcome": "Outcome",
  "common.owner": "Owner",
  "common.pageNotFound": "Page not found",
  "common.parent": "Parent",
  "common.parentDisplayName": "Parent display name",
  "common.parentSupergroupId": "Parent Supergroup id",
  "common.parentSupergroupMember": "This user is already a member of the parent Supergroup",
  "common.pending": "pending",
  "common.peopleLoadFailed": "People could not be loaded. Try again shortly.",
  "common.photoBlobKey": "Photo blob key",
  "common.policyIdentityStaffScope": "Policy, identity, and staff-profile controls are organization-scoped.",
  "common.policyNameExample": "Policy name, e.g. Default Org Governance",
  "common.policySettings": "Policy & Settings",
  "common.postMessage": "Post a message",
  "common.preCheckChecked": "Checked {time}. This is informal and does not gate verification.",
  "common.preCheckNotes": "Notes (visible to Managers, hidden from the list owner)",
  "common.preCheckNotesHidden": "Notes are not shown to the list owner.",
  "common.preCheckOptional": "Optional, informal, and does not gate verification. Only available to Team Leaders.",
  "common.preCheckRecorded": "Pre-check recorded.",
  "common.previouslySelectedPerson": "Previously selected person",
  "common.priority": "Priority",
  "common.react": "React",
  "common.reactionCodePlaceholder": "Reaction code, e.g. thumbsup",
  "common.reactivate": "Reactivate",
  "common.readOnly": "Read-only",
  "common.readOnlyProjection": "Read-only projection",
  "common.readOnlyScope": "Read-only web scope",
  "common.realOwner": "Real owner",
  "common.reason": "Reason",
  "common.recentlyUpdated": "Recently updated",
  "common.recordPreCheck": "Record a pre-check",
  "common.redact": "Redact",
  "common.refresh": "Refresh",
  "common.reject": "Reject",
  "common.rejectList": "Reject list",
  "common.rejected": "Rejected.",
  "common.rename": "Rename",
  "common.requestStaffLoan": "Request a staff loan",
  "common.retry": "Retry",
  "common.review": "Review",
  "common.revoke": "Revoke",
  "common.ruleKeyToEvaluate": "rule key to evaluate",
  "common.save": "Save",
  "common.saved": "Saved.",
  "common.saving": "Saving…",
  "common.search": "Search",
  "common.selfAuthored": "Self-authored",
  "common.send": "Send",
  "common.sendConnectionRequest": "Send a connection request (recipient user id)",
  "common.sending": "Sending…",
  "common.serverLocation": "Server location",
  "common.size": "Size",
  "common.staffLoanApprovalNote": "Requires the real owner's approval before it takes effect — see the Loans list below once submitted.",
  "common.staffLoanApprove": "Approved.",
  "common.staffLoanDecline": "Declined.",
  "common.staffLoanDescription": "Temporary reassignment of a staff member's working authority to another manager.",
  "common.staffLoanEnd": "Ended.",
  "common.staffLoanExtend": "Extended.",
  "common.staffLoanOwnersMustDiffer": "The real owner and borrowing manager must be different people.",
  "common.staffLoanRequested": "Staff loan requested.",
  "common.staffMember": "Staff member",
  "common.staffProfiles": "Staff Profiles",
  "common.status": "Status",
  "common.submittedForVerification": "Submitted for verification.",
  "common.submitting": "Submitting…",
  "common.systemOrganization": "Reserved system organization",
  "common.targetCreated": "Target created.",
  "common.targetIdUuid": "Target id (UUID)",
  "common.targetTypeExample": "Target type, e.g. file_asset",
  "common.targets": "Targets",
  "common.teamLeaderPreCheck": "Team Leader pre-check",
  "common.teamMemberships": "Team memberships (;-separated)",
  "common.thisComputer": "This computer",
  "common.title": "Title",
  "common.todoListCreated": "Todo list created.",
  "common.todoLists": "Todo lists",
  "common.todoStartsWithOneItem": "Starts with one item — add more from the detail view once created.",
  "common.todoTargetsDescription": "Task lists and time-bound targets, verified by the owner's manager.",
  "common.todosAndTargets": "Todos & Targets",
  "common.total_items": "Total items",
  "common.type": "Type",
  "common.unclassified": "Unclassified",
  "common.unreact": "Un-react",
  "common.untitled": "(untitled)",
  "common.updated": "Updated",
  "common.upload": "Upload",
  "common.uploading": "Uploading…",
  "common.userAccessDescription": "Create, classify, and maintain organization access with explicit account state.",
  "common.userIdUuid": "User id (UUID)",
  "common.verified": "Verified.",
  "common.verify": "Verify",
  "common.verifyList": "Verify list",
  "common.version": "Version",
  "common.view": "View",
  "common.viewAll": "View all",
  "common.viewHoldById": "View a hold by id",
  "common.viewMessageById": "View a message by id",
  "common.viewOnly": "View only",
  "common.viewRequestById": "View a request by id",
  "common.whatDoesTargetMean": "What does hitting this target mean?",
  "common.windowEnds": "Window ends",
  "common.windowStarts": "Window starts",
  "common.yes": "Yes",
  "status.acknowledged": "Acknowledged",
  "status.active": "Active",
  "status.approved": "Approved",
  "status.blocked": "Blocked",
  "status.completed": "Completed",
  "status.empty": "Empty",
  "status.failed": "Failed",
  "status.loading": "Loading",
  "status.paused": "Paused",
  "status.pending": "Pending",
  "status.rejected": "Rejected",
  "status.stale": "Stale",
  "status.submitted": "Submitted",
  "status.unacknowledged": "Unacknowledged",
  "status.unavailable": "Unavailable",
  "dashboard.activeMissions": "Active missions",
  "dashboard.attentionRequired": "Attention required",
  "dashboard.blockedAlertsNeedReview": "Needs review — blocked tasks: {blocked}, unread notifications: {unread}.",
  "dashboard.blockedTasks": "Blocked tasks",
  "dashboard.commandCenterOverview": "Command center overview for this replica.",
  "dashboard.connectedTo": "Connected to",
  "dashboard.createFirstMission": "Create the first mission from the Missions tab.",
  "dashboard.failedToLoadSyncStatus": "Failed to load sync status",
  "dashboard.forOrganization": "for organization",
  "dashboard.latestChanges": "Latest changes",
  "dashboard.noActivity": "No activity recorded yet.",
  "dashboard.noBlockedAlerts": "No blocked tasks or unread operational alerts.",
  "dashboard.noMissionsVisible": "No missions visible to your account.",
  "dashboard.openConflicts": "Open conflicts",
  "dashboard.openMissions": "Open Missions",
  "dashboard.openTasks": "Open tasks",
  "dashboard.operationalOverview": "Operational overview",
  "dashboard.operationsStable": "Operations stable",
  "dashboard.operatorQueue": "Operator queue",
  "dashboard.pendingApprovals": "Pending approvals",
  "dashboard.pendingOutbox": "Pending outbox",
  "dashboard.recentActivity": "Recent activity",
  "dashboard.recentMissions": "Recent missions",
  "dashboard.reviewApprovals": "Review Approvals",
  "dashboard.syncStatus": "Sync status",
  "dashboard.title": "Dashboard",
  "dashboard.unreadNotifications": "Unread notifications",
  "dashboard.workQueue": "Work queue",
  "missions.authorityEpoch": "Authority epoch",
  "missions.authorityState": "Authority state",
  "missions.createMission": "Create mission",
  "missions.descriptionPlaceholder": "Description (optional)",
  "missions.executionState": "Execution state",
  "missions.lifecycleEpoch": "Lifecycle epoch",
  "missions.lookupByMissionId": "Look up by mission id (JSON array of 16 bytes)",
  "missions.namePlaceholder": "Mission name",
  "missions.newMission": "New Mission",
  "missions.noMissionFoundForId": "No mission found for this id.",
  "missions.noMissions": "No missions",
  "missions.noMissionsBody": "No mission projections are currently available for this organization.",
  "missions.noMissionsYet": "No missions yet",
  "missions.noTimelineEntries": "No timeline entries in this projection.",
  "missions.portfolio": "Mission portfolio",
  "missions.progress": "Progress",
  "missions.reasonRequired": "Reason (required)",
  "missions.reviewApproval": "Review approval request",
  "missions.reviewPurposeOwnership": "Review purpose, ownership, lifecycle status, and temporal constraints.",
  "missions.singular": "Mission",
  "missions.timeline": "Timeline",
  "missions.title": "Missions",
  "missions.unavailableBackToMissions": "Mission unavailable — back to missions",
  "missions.unnamed": "(unnamed)",
  "tasks.authorityEpoch": "Authority epoch",
  "tasks.createTask": "Create task",
  "tasks.descriptionPlaceholder": "Description (optional)",
  "tasks.executionVisibility": "Execution visibility",
  "tasks.executionVisibilityNote": "Inspect operational work without introducing client-side lifecycle logic.",
  "tasks.lifecycleEpoch": "Lifecycle epoch",
  "tasks.loading": "Loading tasks",
  "tasks.lookupByTaskId": "Look up by task id (JSON array of 16 bytes)",
  "tasks.missionIdPlaceholder": "Mission id (JSON array of 16 bytes; leave blank for a random placeholder)",
  "tasks.nativeClientRequired": "Task lifecycle and ownership changes require a native client.",
  "tasks.newTask": "New Task",
  "tasks.noMatch": "No tasks match this view",
  "tasks.noTaskFoundForId": "No task found for this id.",
  "tasks.noTasks": "No tasks are stored on this device.",
  "tasks.noTasksVisible": "No tasks visible to your account.",
  "tasks.reviewOwnershipPriorityDue": "Review task ownership, priority, and due dates.",
  "tasks.singular": "Task",
  "tasks.staffWorkflow": "Staff workflow",
  "tasks.title": "Tasks",
  "tasks.titlePlaceholder": "Task title",
  "tasks.unavailableBackToTasks": "Task unavailable — back to tasks",
  "notifications.acknowledge": "Acknowledge",
  "notifications.acknowledging": "Acknowledging…",
  "notifications.acknowledgmentNote": "Acknowledgment is sent to the server immediately. Failed commands are never queued locally.",
  "notifications.deliveryCenter": "Delivery center",
  "notifications.desktopLocalReplicaNote": "Notifications addressed to you in this device's local ONYX replica.",
  "notifications.enable": "Enable notifications",
  "notifications.loading": "Loading notifications",
  "notifications.loadingDesktop": "Loading notifications…",
  "notifications.noLocalNotifications": "You have no notifications in this local replica.",
  "notifications.noNotifications": "No notifications",
  "notifications.noNotificationsBody": "No notification projections are currently available for this organization.",
  "notifications.operationalAlerts": "Operational alerts",
  "notifications.pushDenied": "Permission was denied — allow notifications for this site in your browser settings.",
  "notifications.pushNotifications": "Push notifications",
  "notifications.pushReadOnlyNote": "Observer notifications are delivered read-only; this client never sends commands.",
  "notifications.pushUnconfigured": "The server has not published a VAPID public key, so push delivery cannot be set up yet.",
  "notifications.pushUnsupported": "Push notifications are not supported in this browser.",
  "notifications.title": "Notifications",
  "notifications.webPushDelivery": "Web Push delivery",
  "approvals.authorityWorkflow": "Authority workflow",
  "approvals.decisionsPinned": "Decisions are pinned to the displayed target version and epochs.",
  "approvals.escalatedToYou": "Escalated to you",
  "approvals.loading": "Loading approvals",
  "approvals.lookupTaskToReview": "Look up a task by id to review it. Only tasks in the",
  "approvals.nativeClientRequired": "Native client required",
  "approvals.noApprovals": "No approvals",
  "approvals.noApprovalsBody": "No approval projections are currently available for this organization.",
  "approvals.notAwaitingApproval": "This task is not awaiting approval.",
  "approvals.pendingCount": "{count} pending",
  "approvals.requestedBy": "Requested by",
  "approvals.reviewSubmission": "Review submission",
  "approvals.submittedOnlyNote": "state can be approved or rejected.",
  "approvals.target": "Target",
  "approvals.title": "Approvals",
  "approvals.webDecisionNotPermitted": "Web-based decision is not permitted by policy.",
  "reports.evidenceReferences": "Evidence references",
  "reports.evidenceViewer": "Evidence viewer",
  "reports.noAttachments": "No attachments referenced.",
  "reports.noPublishedReport": "No published report",
  "reports.noPublishedReportProjection": "No published report projection is available.",
  "reports.noReport": "The report projection is unavailable.",
  "reports.operationalReport": "Operational report",
  "reports.readOnlyAccess": "Read-only access to published report projections and attachment references.",
  "reports.summary": "Summary",
  "reports.title": "Reports",
  "files.access": "Access",
  "files.archive": "Archive",
  "files.bytesWrittenTo": "{count} bytes written to {path}",
  "files.contentAddressedFile": "Content-addressed file",
  "files.contentHash": "Content hash",
  "files.destinationRequired": "Enter a destination path first.",
  "files.downloadDestination": "Download destination path",
  "files.downloadFile": "Download a file",
  "files.downloadPathPlaceholder": "/home/user/downloads/report.pdf",
  "files.filePath": "File path on this device",
  "files.grant": "Grant",
  "files.invalidContentHash": "Invalid content hash.",
  "files.invalidContentHashHelp": "A content hash must be a lowercase hex string. This page is reachable only with a valid hash.",
  "files.lookupByFileId": "Look up by file id (JSON array of 16 bytes)",
  "files.noFileFoundForId": "No file found for this id.",
  "files.noVersions": "No versions recorded yet. A file uploaded through this app records its first version automatically.",
  "files.quarantine": "Quarantine",
  "files.revoke": "Revoke",
  "files.saveToDevice": "Save to path on this device",
  "files.title": "Files",
  "files.unknownType": "unknown",
  "files.unnamed": "(unnamed)",
  "files.uploadFile": "Upload a file",
  "files.uploadPathNote": "Enter the full path of a file on this machine. Maximum",
  "files.uploadPathPlaceholder": "/home/user/documents/report.pdf",
  "files.uploadedContentHash": "Uploaded. Content hash:",
  "files.userIdPlaceholder": "User id [12,34,...]",
  "files.versionSummary": "v{version} · {size} bytes",
  "files.versions": "Versions",
  "settings.checking": "Checking…",
  "settings.cloudRelay": "Cloud relay endpoint",
  "settings.cloudRelaySaved": "Cloud relay endpoint saved. Restart the app to apply it.",
  "settings.cloudServiceNote": "ONYX uses its managed Cloud service for authentication and data.",
  "settings.desktopConnectionNote": "Review the connection used by this staff desktop application.",
  "settings.legalHoldMissingConcurrencyEpochs": "This projection is missing concurrency epochs. Refresh before releasing the hold.",
  "settings.localDb": "Local-first database",
  "settings.lookupPolicyById": "Look up by policy id (UUID)",
  "settings.mobileAccessEnforcementDisabled": "Configuration is saved, but mobile-login enforcement is disabled. The client-supplied client_type can be spoofed and is not a trusted authorization signal. Do not rely on this setting to restrict sign-in until server-verifiable client identity or attestation is implemented.",
  "settings.mobileAccessPolicyDescription": "Configure the user classes intended for mobile access. Saving persists the policy; its enforcement status is shown separately below.",
  "settings.mobileAccessPolicyScope": "This class-based policy is enforced for selected protected capabilities after authentication. It does not block sign-in or identify a mobile device; client_type is not an authorization signal.",
  "settings.noLegalHoldFound": "No legal hold found for this ID.",
  "settings.organizationPolicyDescription": "Organization policy: feature availability, limits, retention, and legal holds.",
  "settings.p2pSync": "Peer-to-peer sync",
  "settings.policyMissingConcurrencyEpochs": "This projection is missing concurrency epochs. Refresh before changing this policy.",
  "settings.publishDraft": "Publish draft",
  "settings.release": "Release",
  "settings.retirePolicy": "Retire policy",
  "settings.retryApplicationSafely": "Retry application safely",
  "settings.retryCreationSafely": "Retry creation safely",
  "settings.returnToDashboard": "Return to dashboard",
  "settings.signingOut": "Signing out…",
  "settings.title": "Settings",
  "language.note": "Interface language. Applies instantly and is remembered on this device.",
  "language.title": "Language"
} as Record<string, string>;
export const fa: Record<string, string> = {
  "app.name": "ONYX",
  "app.observer": "ناظر ONYX",
  "app.remoteOperator": "اپراتور راه‌دور",
  "app.tagline": "عملیات مأموریت",
  "app.thinClient": "کلاینت سبک",
  "app.thinClientNote": "بدون دستور آفلاین یا وضعیت دامنه محلی.",
  "nav.approvals": "تأییدها",
  "nav.closeMenu": "بستن ناوبری",
  "nav.dashboard": "داشبورد",
  "nav.files": "فایل‌ها",
  "nav.home": "خانه",
  "nav.menu": "منو",
  "nav.messaging": "پیام‌ها",
  "nav.missions": "مأموریت‌ها",
  "nav.nativeOperationalWorkspace": "محیط عملیاتی بومی",
  "nav.notifications": "اعلان‌ها",
  "nav.openMenu": "باز کردن ناوبری",
  "nav.organizations": "سازمان‌ها",
  "nav.overview": "نمای کلی",
  "nav.primary": "ناوبری اصلی",
  "nav.profiles": "پروفایل‌ها",
  "nav.reports": "گزارش‌ها",
  "nav.settings": "تنظیمات",
  "nav.skipToContent": "پرش به محتوای اصلی",
  "nav.staffDesktop": "دسکتاپ پرسنل",
  "nav.staffDesktopNote": "نسخه محلی با وضعیت همگام‌سازی شفاف و دستورهای محافظت‌شده.",
  "nav.staffLoans": "واگذاری پرسنل",
  "nav.staffOperator": "اپراتور پرسنل",
  "nav.staffWorkspace": "محیط کاری پرسنل",
  "nav.tasks": "وظایف",
  "nav.todos": "کارها و اهداف",
  "nav.users": "کاربران",
  "auth.adminAccessRequired": "دسترسی مدیر لازم است",
  "auth.adminAccountForOrganization": "برای این سازمان از یک حساب مدیر استفاده کنید.",
  "auth.adminConnectionSecurity": "امنیت اتصال",
  "auth.adminCredentialsDescription": "مدیران و All-Father با نام کاربری و گذرواژه ONYX خود وارد می‌شوند.",
  "auth.adminHeroDescription": "سیاست سازمان، دسترسی و پروفایل کارکنان را از یک فضای کاری مدیریتی اختصاصی مدیریت کنید.",
  "auth.adminHeroHeadline": "عملیات را با کنترل آرام و شفاف هدایت کنید.",
  "auth.adminInvalidCredentials": "نام کاربری یا گذرواژه نامعتبر است.",
  "auth.adminOrganizationAdministration": "مدیریت در سطح سازمان · تأیید صریح سرور",
  "auth.adminSecureAccess": "دسترسی امن مدیر",
  "auth.adminSession": "نشست مدیر",
  "auth.adminSignIn": "ورود به ONYX",
  "auth.adminTitle": "مدیر",
  "auth.adminTitleBar": "مدیر ONYX",
  "auth.allFatherAuthority": "مرجعیت ALL-FATHER",
  "auth.desktopHeroBody": "کار مأموریت را بررسی کنید، تأییدها را رسیدگی کنید و با وضعیت همگام‌سازی محلی شفاف اقدام کنید.",
  "auth.desktopHeroTitle": "شفافیت عملیاتی، از هر دسکتاپ مجاز.",
  "auth.heroBody": "مأموریت‌ها را بررسی کنید، کارهای حساس را پایش کنید، اعلان‌ها را تأیید کنید و تصمیم‌های تأییدی مجاز را بدون نصب نسخه بومی بگیرید.",
  "auth.heroTitle": "شفافیت عملیاتی، از هر مرورگر مجاز.",
  "auth.initialPassword": "رمز عبور اولیه",
  "auth.invalidCredentials": "نام کاربری یا گذرواژه نامعتبر است.",
  "auth.logOut": "خروج",
  "auth.nativeReplicaProtectedSession": "نسخه بومی دسکتاپ · دستورهای مرجع‌محور سرور · نشست محافظت‌شده",
  "auth.password": "گذرواژه",
  "auth.productIntroduction": "معرفی محصول ONYX",
  "auth.retryGoogleListener": "تلاش دوباره برای آماده‌سازی بازگشت ورود",
  "auth.secureBrowserAccess": "دسترسی امن مرورگر",
  "auth.secureDesktopAccess": "دسترسی امن دسکتاپ",
  "auth.sessionNote": "دسترسی منقضی نیازمند ورود مجدد است. چرخش توکن در نسخه ۱ عمداً غیرفعال است.",
  "auth.sessionSecurity": "امنیت نشست",
  "auth.signIn": "ورود",
  "auth.signInToOnyx": "ورود به ONYX",
  "auth.signOut": "خروج",
  "auth.signOutRetry": "خروج و تلاش مجدد",
  "auth.signedIn": "وارد شده",
  "auth.signingIn": "در حال ورود…",
  "auth.signingOut": "در حال خروج…",
  "auth.staffOperations": "عملیات پرسنل",
  "auth.staffOperator": "اپراتور پرسنل",
  "auth.test": "آزمایش",
  "auth.testing": "در حال آزمایش…",
  "auth.thinClientServerAuthoritative": "کلاینت سبک · سرور مرجع اقتدار · بدون صف دستور آفلاین",
  "auth.tokensProtectedNative": "توکن‌ها در ذخیره‌سازی بومی محافظت‌شده نگه‌داری می‌شوند. هنگام تغییر سرور، احراز هویت مجدد لازم است.",
  "auth.useAssignedCredentials": "از نام کاربری و رمز عبور اختصاص‌یافته به حساب ONYX خود استفاده کنید.",
  "auth.useOrgCredentials": "از اعتبار سازمانی خود استفاده کنید. این مرورگر توکن‌ها را فقط برای همین نشست نگه می‌دارد.",
  "auth.useOrgCredentialsNative": "از اعتبار سازمانی خود استفاده کنید. نشست شما در ذخیره‌سازی بومی امن این دستگاه نگه‌داری می‌شود.",
  "auth.username": "نام کاربری",
  "common.accept": "پذیرش",
  "common.account": "حساب",
  "common.actions": "اقدامات",
  "common.activate": "فعال‌سازی",
  "common.add": "افزودن",
  "common.addAnotherItem": "افزودن مورد دیگر",
  "common.addMemberUserId": "افزودن عضو (شناسه کاربر)",
  "common.addRule": "افزودن قانون",
  "common.admin": "مدیر",
  "common.adminConnectionHelp": "محل اتصال مدیریت ONYX را انتخاب کنید. نشانی فقط پس از بررسی موفق سلامت ذخیره می‌شود.",
  "common.adminPlatform": "پلتفرم مدیریت",
  "common.adminPrimaryNavigation": "ناوبری اصلی مدیریت",
  "common.administration": "مدیریت",
  "common.administrativeControlPlane": "صفحه کنترل مدیریتی",
  "common.administrativeWorkspace": "فضای کاری مدیریتی",
  "common.administrator": "مدیر",
  "common.all": "همه",
  "common.allFatherAdministration": "مدیریت کل سامانه",
  "common.allLoans": "همه واگذاری‌ها",
  "common.anotherComputer": "رایانه دیگر",
  "common.approvalGranted": "تأیید اعطا شد.",
  "common.approvalRejected": "تأیید رد شد.",
  "common.approve": "تأیید",
  "common.assignee": "مسئول",
  "common.assignmentQuestion": "این کار برای چه کسی است؟",
  "common.batchImportExport": "درون‌ریزی / برون‌بری گروهی",
  "common.borrowingManager": "مدیر دریافت‌کننده",
  "common.cancel": "لغو",
  "common.checkingConnection": "در حال بررسی اتصال",
  "common.chooseBorrowingManager": "مدیری را که اختیار موقت دریافت می‌کند انتخاب کنید",
  "common.chooseLoanedStaff": "عضو پرسنلی را که واگذار می‌شود انتخاب کنید",
  "common.chooseOwner": "فردی را که مالک این کار خواهد بود انتخاب کنید",
  "common.chooseOwningManager": "مدیر مالک عضو پرسنل را انتخاب کنید",
  "common.choosePerson": "یک نفر را انتخاب کنید",
  "common.class": "طبقه",
  "common.classLabel": "برچسب طبقه",
  "common.close": "بستن",
  "common.commandsNotQueued": "دستورها در صف قرار نمی‌گیرند. دوباره متصل شوید و سپس اقدام را تکرار کنید.",
  "common.comment": "نظر",
  "common.confirmActivateOrganization": "این سازمان دوباره فعال شود؟ سوابق حفظ می‌شوند و نشست‌های قبلی همچنان باطل می‌مانند.",
  "common.confirmDeactivateOrganization": "این سازمان غیرفعال شود؟ دسترسی اعضا متوقف و نشست‌های فعال آن‌ها باطل می‌شود تا پس از فعال‌سازی دوباره وارد شوند.",
  "common.confirmDeactivateOrganizationAdmin": "این مدیر سازمان غیرفعال شود؟ دسترسی او متوقف و نشست‌های فعالش باطل می‌شود.",
  "common.confirmDecline": "تأیید رد",
  "common.confirmEscalate": "تأیید ارجاع",
  "common.confirmExtension": "تأیید تمدید",
  "common.confirmReject": "تأیید رد",
  "common.confirmVerify": "تأیید راستی‌آزمایی",
  "common.conflicts": "تعارض",
  "common.connected": "متصل",
  "common.connectionLost": "ارتباط قطع شد.",
  "common.connectionSetup": "تنظیم اتصال",
  "common.connectionVerifiedBeforeSave": "تنظیمات اتصال پیش از ذخیره بررسی می‌شوند.",
  "common.connections": "ارتباط‌ها",
  "common.contact": "تماس",
  "common.contactEmail": "ایمیل تماس",
  "common.contactPhone": "تلفن تماس",
  "common.create": "ایجاد",
  "common.createConversation": "ایجاد گفت‌وگو",
  "common.createOrganization": "ایجاد سازمان",
  "common.createOrganizationAdmin": "ایجاد مدیر سازمان",
  "common.createPolicy": "ایجاد سیاست",
  "common.createTarget": "ایجاد هدف",
  "common.createTodoList": "ایجاد فهرست کار",
  "common.createUser": "ایجاد کاربر",
  "common.creating": "در حال ایجاد…",
  "common.deactivate": "غیرفعال‌سازی",
  "common.decisionEscalatedToYou": "این تصمیم راستی‌آزمایی به شما ارجاع شده است.",
  "common.decline": "رد",
  "common.declineReasonRequired": "دلیل رد (الزامی)",
  "common.department": "واحد سازمانی",
  "common.description": "توضیح",
  "common.disable": "غیرفعال کردن",
  "common.disabling": "در حال غیرفعال‌سازی…",
  "common.disconnected": "قطع اتصال",
  "common.download": "دانلود",
  "common.downloading": "در حال دانلود…",
  "common.draftNewVersion": "ایجاد پیش‌نویس نسخه جدید",
  "common.due": "موعد",
  "common.edit": "ویرایش",
  "common.editProfile": "ویرایش پروفایل",
  "common.enabling": "در حال فعال‌سازی…",
  "common.endEarly": "پایان زودهنگام",
  "common.english": "English",
  "common.escalate": "ارجاع",
  "common.escalateList": "ارجاع فهرست",
  "common.escalated": "ارجاع شد.",
  "common.evaluate": "ارزیابی",
  "common.exportCsv": "خروجی CSV",
  "common.exportJson": "خروجی JSON",
  "common.extend": "تمدید",
  "common.farsi": "فارسی",
  "common.firstItemExample": "مورد اول، مثلاً نوشتن گزارش هفتگی",
  "common.fullName": "نام کامل",
  "common.grantAdministratorAccess": "اعطای دسترسی مدیریتی",
  "common.id16Placeholder": "[12,34,...]",
  "common.identityManagement": "مدیریت هویت",
  "common.importing": "در حال درون‌ریزی…",
  "common.inactive": "غیرفعال",
  "common.inputValue": "مقدار",
  "common.involvingMe": "مرتبط با من",
  "common.itemAdded": "مورد اضافه شد.",
  "common.items": "موارد",
  "common.itemsCount": "{count} مورد",
  "common.jobTitle": "عنوان شغلی",
  "common.keyExample": "کلید، برای مثال messaging.enabled",
  "common.language": "زبان",
  "common.legalHolds": "نگهداشت‌های قانونی",
  "common.listKind": "نوع فهرست",
  "common.loading": "در حال بارگذاری…",
  "common.loadingAdmin": "در حال بارگذاری پنل مدیریت ONYX…",
  "common.loadingOnyx": "در حال بارگذاری ONYX…",
  "common.loadingPeople": "در حال بارگذاری افراد…",
  "common.loadingSecureSession": "در حال بارگذاری نشست امن…",
  "common.loanEnds": "پایان واگذاری",
  "common.loanStarts": "شروع واگذاری",
  "common.loans": "واگذاری‌ها",
  "common.lookup": "جست‌وجو",
  "common.lookupByConversationId": "جست‌وجو بر اساس شناسه گفت‌وگو (آرایه JSON شامل ۱۶ بایت)",
  "common.manageAdmins": "مدیریت مدیران",
  "common.managerAssigned": "واگذارشده توسط مدیر",
  "common.messageTextPlaceholder": "متن پیام",
  "common.mobileAccess": "دسترسی موبایل",
  "common.name": "نام",
  "common.newAccount": "حساب جدید",
  "common.newAccountDescription": "حساب‌های جدید فقط طبقه‌بندی و دسترسی مدیریتی انتخاب‌شده در اینجا را دریافت می‌کنند.",
  "common.newEndDateTime": "تاریخ/زمان پایان جدید",
  "common.newProfile": "پروفایل جدید",
  "common.newTextPlaceholder": "متن جدید",
  "common.noActionsAvailable": "در این وضعیت اقدامی در دسترس نیست.",
  "common.noClass": "بدون طبقه",
  "common.noConversationFoundForId": "گفت‌وگویی با این شناسه پیدا نشد.",
  "common.noData": "داده‌ای موجود نیست.",
  "common.noItems": "موردی وجود ندارد.",
  "common.noLoanApprovalsEscalated": "هیچ تأیید واگذاری‌ای به شما ارجاع نشده است.",
  "common.noLoansInvolvingYou": "هنوز واگذاری‌ای مرتبط با شما وجود ندارد.",
  "common.noLoansYetRequestOne": "هنوز واگذاری‌ای وجود ندارد. از بالا یک درخواست ثبت کنید.",
  "common.noOrganizationAdminsYet": "برای این سازمان مدیری ثبت نشده است.",
  "common.noOrganizationsYet": "هنوز سازمانی ایجاد نشده است.",
  "common.noParent": "بدون سرپرست",
  "common.noPeopleMatch": "هیچ فردی با این جست‌وجو مطابقت ندارد.",
  "common.noPolicyFound": "سیاستی برای این شناسه پیدا نشد.",
  "common.noProfilesYet": "هنوز پروفایلی وجود ندارد.",
  "common.noSelection": "برای مشاهده جزئیات یک مورد را انتخاب کنید.",
  "common.noVersionsYet": "هنوز نسخه‌ای وجود ندارد.",
  "common.notificationAcknowledged": "اعلان تأیید شد.",
  "common.observerProjectionNotFound": "این نمای پروژکشن بخشی از سطح کلاینت ناظر نیست.",
  "common.offline": "آفلاین",
  "common.offlineSnapshot": "شما آفلاین هستید — آخرین نما نمایش داده می‌شود.",
  "common.online": "آنلاین",
  "common.onlyOwnerCanSubmit": "فقط مالک می‌تواند این فهرست را ارسال کند.",
  "common.open": "باز کردن",
  "common.operationalClass": "کلاس عملیاتی",
  "common.organization": "سازمان",
  "common.organizationAdmins": "مدیران سازمان",
  "common.organizationInactive": "این سازمان غیرفعال است. تا زمان فعال‌سازی مجدد، حساب‌های مدیران نمی‌توانند وارد شوند.",
  "common.organizationManagementDescription": "سازمان‌ها را ایجاد و حساب مدیران آن‌ها را مدیریت کنید. غیرفعال‌سازی دسترسی را متوقف می‌کند و سوابق را حذف نمی‌کند.",
  "common.organizationName": "نام سازمان",
  "common.organizations": "سازمان‌ها",
  "common.origin": "مبدأ",
  "common.outcome": "نتیجه",
  "common.owner": "مالک",
  "common.pageNotFound": "صفحه پیدا نشد",
  "common.parent": "سرپرست",
  "common.parentDisplayName": "نام نمایشی سرپرست",
  "common.parentSupergroupId": "شناسه ابرگروه والد",
  "common.parentSupergroupMember": "این کاربر از قبل عضو ابرگروه والد است",
  "common.pending": "در انتظار",
  "common.peopleLoadFailed": "بارگذاری افراد ممکن نشد. کمی بعد دوباره تلاش کنید.",
  "common.photoBlobKey": "کلید داده عکس",
  "common.policyIdentityStaffScope": "کنترل‌های سیاست، هویت و پروفایل کارکنان در سطح سازمان هستند.",
  "common.policyNameExample": "نام سیاست، برای مثال Default Org Governance",
  "common.policySettings": "سیاست و تنظیمات",
  "common.postMessage": "ارسال پیام",
  "common.preCheckChecked": "در {time} بررسی شد. این بررسی غیررسمی است و مانع راستی‌آزمایی نمی‌شود.",
  "common.preCheckNotes": "یادداشت‌ها (برای مدیران قابل مشاهده و برای مالک فهرست پنهان است)",
  "common.preCheckNotesHidden": "یادداشت‌ها به مالک فهرست نمایش داده نمی‌شوند.",
  "common.preCheckOptional": "اختیاری و غیررسمی است و مانع راستی‌آزمایی نمی‌شود. فقط برای سرپرستان تیم در دسترس است.",
  "common.preCheckRecorded": "پیش‌بررسی ثبت شد.",
  "common.previouslySelectedPerson": "فرد انتخاب‌شده قبلی",
  "common.priority": "اولویت",
  "common.react": "واکنش",
  "common.reactionCodePlaceholder": "کد واکنش، مانند thumbsup",
  "common.reactivate": "فعال‌سازی مجدد",
  "common.readOnly": "فقط‌خواندنی",
  "common.readOnlyProjection": "پروژکشن فقط‌خواندنی",
  "common.readOnlyScope": "دامنه وب فقط‌خواندنی",
  "common.realOwner": "مالک واقعی",
  "common.reason": "دلیل",
  "common.recentlyUpdated": "به‌تازگی به‌روزرسانی شده",
  "common.recordPreCheck": "ثبت پیش‌بررسی",
  "common.redact": "حذف محتوایی",
  "common.refresh": "تازه‌سازی",
  "common.reject": "رد",
  "common.rejectList": "رد فهرست",
  "common.rejected": "رد شد.",
  "common.rename": "تغییر نام",
  "common.requestStaffLoan": "درخواست واگذاری پرسنل",
  "common.retry": "تلاش مجدد",
  "common.review": "بررسی",
  "common.revoke": "لغو",
  "common.ruleKeyToEvaluate": "کلید قانون برای ارزیابی",
  "common.save": "ذخیره",
  "common.saved": "ذخیره شد.",
  "common.saving": "در حال ذخیره‌سازی…",
  "common.search": "جست‌وجو",
  "common.selfAuthored": "ایجادشده توسط خود فرد",
  "common.send": "ارسال",
  "common.sendConnectionRequest": "ارسال درخواست ارتباط (شناسه کاربر گیرنده)",
  "common.sending": "در حال ارسال…",
  "common.serverLocation": "محل سرور",
  "common.size": "اندازه",
  "common.staffLoanApprovalNote": "پیش از اجرا به تأیید مالک واقعی نیاز دارد — پس از ارسال، آن را در فهرست واگذاری‌ها ببینید.",
  "common.staffLoanApprove": "تأیید شد.",
  "common.staffLoanDecline": "رد شد.",
  "common.staffLoanDescription": "واگذاری موقت اختیار کاری یک عضو پرسنل به مدیر دیگری.",
  "common.staffLoanEnd": "پایان یافت.",
  "common.staffLoanExtend": "تمدید شد.",
  "common.staffLoanOwnersMustDiffer": "مالک واقعی و مدیر قرض‌گیرنده باید دو نفر متفاوت باشند.",
  "common.staffLoanRequested": "درخواست واگذاری پرسنل ثبت شد.",
  "common.staffMember": "عضو پرسنل",
  "common.staffProfiles": "پروفایل کارکنان",
  "common.status": "وضعیت",
  "common.submittedForVerification": "برای راستی‌آزمایی ارسال شد.",
  "common.submitting": "در حال ارسال…",
  "common.systemOrganization": "سازمان رزروشده سامانه",
  "common.targetCreated": "هدف ایجاد شد.",
  "common.targetIdUuid": "شناسه هدف (UUID)",
  "common.targetTypeExample": "نوع هدف، برای مثال file_asset",
  "common.targets": "اهداف",
  "common.teamLeaderPreCheck": "پیش‌بررسی سرپرست تیم",
  "common.teamMemberships": "عضویت‌های تیمی (با ; جدا شود)",
  "common.thisComputer": "این رایانه",
  "common.title": "عنوان",
  "common.todoListCreated": "فهرست کارها ایجاد شد.",
  "common.todoLists": "فهرست‌های کار",
  "common.todoStartsWithOneItem": "با یک مورد شروع می‌شود — پس از ایجاد، موارد بیشتری را از نمای جزئیات اضافه کنید.",
  "common.todoTargetsDescription": "فهرست‌های کار و اهداف زمان‌دار که توسط مدیر مالک راستی‌آزمایی می‌شوند.",
  "common.todosAndTargets": "کارها و اهداف",
  "common.total_items": "تعداد کل موارد",
  "common.type": "نوع",
  "common.unclassified": "طبقه‌بندی‌نشده",
  "common.unreact": "حذف واکنش",
  "common.untitled": "(بدون عنوان)",
  "common.updated": "به‌روزرسانی شده",
  "common.upload": "بارگذاری",
  "common.uploading": "در حال بارگذاری…",
  "common.userAccessDescription": "دسترسی سازمان را با وضعیت صریح حساب ایجاد، طبقه‌بندی و نگهداری کنید.",
  "common.userIdUuid": "شناسه کاربر (UUID)",
  "common.verified": "راستی‌آزمایی شد.",
  "common.verify": "راستی‌آزمایی",
  "common.verifyList": "راستی‌آزمایی فهرست",
  "common.version": "نسخه",
  "common.view": "مشاهده",
  "common.viewAll": "مشاهده همه",
  "common.viewHoldById": "مشاهده نگهداشت با شناسه",
  "common.viewMessageById": "مشاهده پیام بر اساس شناسه",
  "common.viewOnly": "فقط مشاهده",
  "common.viewRequestById": "مشاهده درخواست بر اساس شناسه",
  "common.whatDoesTargetMean": "دستیابی به این هدف به چه معناست؟",
  "common.windowEnds": "پایان بازه",
  "common.windowStarts": "شروع بازه",
  "common.yes": "بله",
  "status.acknowledged": "تأیید دریافت شده",
  "status.active": "فعال",
  "status.approved": "تأیید شده",
  "status.blocked": "مسدود",
  "status.completed": "تکمیل شده",
  "status.empty": "خالی",
  "status.failed": "ناموفق",
  "status.loading": "در حال بارگذاری",
  "status.paused": "متوقف شده",
  "status.pending": "در انتظار",
  "status.rejected": "رد شده",
  "status.stale": "قدیمی",
  "status.submitted": "ارسال شده",
  "status.unacknowledged": "تأیید دریافت نشده",
  "status.unavailable": "ناموجود",
  "dashboard.activeMissions": "مأموریت‌های فعال",
  "dashboard.attentionRequired": "نیازمند توجه",
  "dashboard.blockedAlertsNeedReview": "نیازمند بررسی — وظایف مسدود: {blocked}، اعلان‌های خوانده‌نشده: {unread}",
  "dashboard.blockedTasks": "وظایف مسدود",
  "dashboard.commandCenterOverview": "نمای کلی مرکز فرمان برای این نسخه محلی.",
  "dashboard.connectedTo": "متصل به",
  "dashboard.createFirstMission": "اولین مأموریت را از زبانه مأموریت‌ها بسازید.",
  "dashboard.failedToLoadSyncStatus": "بارگذاری وضعیت همگام‌سازی ناموفق بود",
  "dashboard.forOrganization": "برای سازمان",
  "dashboard.latestChanges": "آخرین تغییرات",
  "dashboard.noActivity": "هنوز فعالیتی ثبت نشده است.",
  "dashboard.noBlockedAlerts": "هیچ وظیفه مسدود یا هشدار عملیاتی خوانده‌نشده‌ای وجود ندارد.",
  "dashboard.noMissionsVisible": "هیچ مأموریتی برای حساب شما قابل مشاهده نیست.",
  "dashboard.openConflicts": "تعارض‌های باز",
  "dashboard.openMissions": "باز کردن مأموریت‌ها",
  "dashboard.openTasks": "وظایف باز",
  "dashboard.operationalOverview": "نمای عملیاتی",
  "dashboard.operationsStable": "عملیات پایدار است",
  "dashboard.operatorQueue": "صف اپراتور",
  "dashboard.pendingApprovals": "تأییدهای در انتظار",
  "dashboard.pendingOutbox": "خروجی‌های در انتظار",
  "dashboard.recentActivity": "فعالیت‌های اخیر",
  "dashboard.recentMissions": "مأموریت‌های اخیر",
  "dashboard.reviewApprovals": "بررسی تأییدها",
  "dashboard.syncStatus": "وضعیت همگام‌سازی",
  "dashboard.title": "داشبورد",
  "dashboard.unreadNotifications": "اعلان‌های خوانده‌نشده",
  "dashboard.workQueue": "صف کار",
  "missions.authorityEpoch": "دوره اختیار",
  "missions.authorityState": "وضعیت اختیار",
  "missions.createMission": "ایجاد مأموریت",
  "missions.descriptionPlaceholder": "توضیحات (اختیاری)",
  "missions.executionState": "وضعیت اجرا",
  "missions.lifecycleEpoch": "دوره چرخه عمر",
  "missions.lookupByMissionId": "جست‌وجو بر اساس شناسه مأموریت (آرایه JSON شامل ۱۶ بایت)",
  "missions.namePlaceholder": "نام مأموریت",
  "missions.newMission": "مأموریت جدید",
  "missions.noMissionFoundForId": "مأموریتی با این شناسه پیدا نشد.",
  "missions.noMissions": "مأموریتی نیست",
  "missions.noMissionsBody": "در حال حاضر هیچ پروژکشن مأموریتی برای این سازمان موجود نیست.",
  "missions.noMissionsYet": "هنوز مأموریتی نیست",
  "missions.noTimelineEntries": "در این پروژکشن ورودی زمانی وجود ندارد.",
  "missions.portfolio": "سبد مأموریت‌ها",
  "missions.progress": "پیشرفت",
  "missions.reasonRequired": "دلیل (الزامی)",
  "missions.reviewApproval": "بررسی درخواست تأیید",
  "missions.reviewPurposeOwnership": "هدف، مالکیت، وضعیت چرخه عمر و محدودیت‌های زمانی را بررسی کنید.",
  "missions.singular": "مأموریت",
  "missions.timeline": "خط زمانی",
  "missions.title": "مأموریت‌ها",
  "missions.unavailableBackToMissions": "مأموریت در دسترس نیست — بازگشت به مأموریت‌ها",
  "missions.unnamed": "(بدون نام)",
  "tasks.authorityEpoch": "دوره اختیار",
  "tasks.createTask": "ایجاد وظیفه",
  "tasks.descriptionPlaceholder": "توضیحات (اختیاری)",
  "tasks.executionVisibility": "نمایش وضعیت اجرا",
  "tasks.executionVisibilityNote": "کار عملیاتی را بدون افزودن منطق چرخه‌عمر سمت کلاینت بررسی کنید.",
  "tasks.lifecycleEpoch": "دوره چرخه عمر",
  "tasks.loading": "در حال بارگذاری وظایف",
  "tasks.lookupByTaskId": "جست‌وجو بر اساس شناسه وظیفه (آرایه JSON شامل ۱۶ بایت)",
  "tasks.missionIdPlaceholder": "شناسه مأموریت (آرایه JSON شامل ۱۶ بایت؛ برای مقدار تصادفی خالی بگذارید)",
  "tasks.nativeClientRequired": "تغییر چرخه‌عمر و مالکیت وظیفه به کلاینت بومی نیاز دارد.",
  "tasks.newTask": "وظیفه جدید",
  "tasks.noMatch": "هیچ وظیفه‌ای با این نما مطابقت ندارد",
  "tasks.noTaskFoundForId": "وظیفه‌ای با این شناسه پیدا نشد.",
  "tasks.noTasks": "هیچ وظیفه‌ای در این دستگاه ذخیره نشده است.",
  "tasks.noTasksVisible": "هیچ وظیفه‌ای برای حساب شما قابل مشاهده نیست.",
  "tasks.reviewOwnershipPriorityDue": "مالکیت، اولویت و موعد وظایف را بررسی کنید.",
  "tasks.singular": "وظیفه",
  "tasks.staffWorkflow": "گردش کار پرسنل",
  "tasks.title": "وظایف",
  "tasks.titlePlaceholder": "عنوان وظیفه",
  "tasks.unavailableBackToTasks": "وظیفه در دسترس نیست — بازگشت به وظایف",
  "notifications.acknowledge": "تأیید دریافت",
  "notifications.acknowledging": "در حال تأیید…",
  "notifications.acknowledgmentNote": "تأیید دریافت فوراً به سرور ارسال می‌شود. دستورهای ناموفق هرگز به‌صورت محلی در صف قرار نمی‌گیرند.",
  "notifications.deliveryCenter": "مرکز تحویل",
  "notifications.desktopLocalReplicaNote": "اعلان‌های خطاب‌شده به شما در نسخه محلی ONYX این دستگاه.",
  "notifications.enable": "فعال‌سازی اعلان‌ها",
  "notifications.loading": "در حال بارگذاری اعلان‌ها",
  "notifications.loadingDesktop": "در حال بارگذاری اعلان‌ها…",
  "notifications.noLocalNotifications": "در این نسخه محلی اعلانی برای شما وجود ندارد.",
  "notifications.noNotifications": "اعلانی وجود ندارد",
  "notifications.noNotificationsBody": "در حال حاضر هیچ پروژکشن اعلانی برای این سازمان موجود نیست.",
  "notifications.operationalAlerts": "هشدارهای عملیاتی",
  "notifications.pushDenied": "اجازه رد شد — اعلان‌ها را برای این سایت در تنظیمات مرورگر مجاز کنید.",
  "notifications.pushNotifications": "اعلان‌های فشاری",
  "notifications.pushReadOnlyNote": "اعلان‌های ناظر فقط‌خواندنی تحویل می‌شوند؛ این کلاینت هرگز فرمانی ارسال نمی‌کند.",
  "notifications.pushUnconfigured": "سرور کلید عمومی VAPID را منتشر نکرده است، بنابراین هنوز امکان راه‌اندازی تحویل فشاری وجود ندارد.",
  "notifications.pushUnsupported": "اعلان‌های فشاری در این مرورگر پشتیبانی نمی‌شوند.",
  "notifications.title": "اعلان‌ها",
  "notifications.webPushDelivery": "تحویل Web Push",
  "approvals.authorityWorkflow": "گردش‌کار اختیار",
  "approvals.decisionsPinned": "تصمیم‌ها به نسخه هدف و epochهای نمایش‌داده‌شده متصل هستند.",
  "approvals.escalatedToYou": "به شما ارجاع شده",
  "approvals.loading": "در حال بارگذاری تأییدها",
  "approvals.lookupTaskToReview": "برای بررسی، یک وظیفه را بر اساس شناسه جست‌وجو کنید. فقط وظایف در وضعیت",
  "approvals.nativeClientRequired": "کلاینت بومی لازم است",
  "approvals.noApprovals": "تأییدی وجود ندارد",
  "approvals.noApprovalsBody": "در حال حاضر هیچ پروژکشن تأییدی برای این سازمان موجود نیست.",
  "approvals.notAwaitingApproval": "این وظیفه در انتظار تأیید نیست.",
  "approvals.pendingCount": "{count} در انتظار",
  "approvals.requestedBy": "درخواست‌شده توسط",
  "approvals.reviewSubmission": "بررسی ارسال",
  "approvals.submittedOnlyNote": "می‌توانند تأیید یا رد شوند.",
  "approvals.target": "هدف",
  "approvals.title": "تأییدها",
  "approvals.webDecisionNotPermitted": "تصمیم‌گیری از طریق وب طبق سیاست مجاز نیست.",
  "reports.evidenceReferences": "ارجاعات شواهد",
  "reports.evidenceViewer": "نمایشگر شواهد",
  "reports.noAttachments": "پیوستی ارجاع نشده است.",
  "reports.noPublishedReport": "گزارش منتشرشده‌ای وجود ندارد",
  "reports.noPublishedReportProjection": "هیچ پروژکشن گزارش منتشرشده‌ای در دسترس نیست.",
  "reports.noReport": "پروژکشن گزارش موجود نیست.",
  "reports.operationalReport": "گزارش عملیاتی",
  "reports.readOnlyAccess": "دسترسی فقط‌خواندنی به پروژکشن‌های گزارش منتشرشده و ارجاعات پیوست‌ها.",
  "reports.summary": "خلاصه",
  "reports.title": "گزارش‌ها",
  "files.access": "دسترسی",
  "files.archive": "بایگانی",
  "files.bytesWrittenTo": "{count} بایت در {path} نوشته شد",
  "files.contentAddressedFile": "فایل با نشانی مبتنی بر محتوا",
  "files.contentHash": "هش محتوا",
  "files.destinationRequired": "ابتدا یک مسیر مقصد وارد کنید.",
  "files.downloadDestination": "مسیر مقصد بارگیری",
  "files.downloadFile": "دانلود فایل",
  "files.downloadPathPlaceholder": "/home/user/downloads/report.pdf",
  "files.filePath": "مسیر فایل در این دستگاه",
  "files.grant": "اعطا",
  "files.invalidContentHash": "هش محتوا نامعتبر است.",
  "files.invalidContentHashHelp": "هش محتوا باید یک رشته هگزادسیمال کوچک باشد. این صفحه فقط با یک هش معتبر قابل دسترسی است.",
  "files.lookupByFileId": "جست‌وجو بر اساس شناسه فایل (آرایه JSON شامل ۱۶ بایت)",
  "files.noFileFoundForId": "فایلی با این شناسه پیدا نشد.",
  "files.noVersions": "هنوز نسخه‌ای ثبت نشده است. فایل بارگذاری‌شده از این برنامه نخستین نسخه خود را به‌صورت خودکار ثبت می‌کند.",
  "files.quarantine": "قرنطینه",
  "files.revoke": "لغو دسترسی",
  "files.saveToDevice": "ذخیره در مسیر این دستگاه",
  "files.title": "فایل‌ها",
  "files.unknownType": "نامشخص",
  "files.unnamed": "(بدون نام)",
  "files.uploadFile": "بارگذاری فایل",
  "files.uploadPathNote": "مسیر کامل یک فایل روی این دستگاه را وارد کنید. حداکثر",
  "files.uploadPathPlaceholder": "/home/user/documents/report.pdf",
  "files.uploadedContentHash": "بارگذاری شد. هش محتوا:",
  "files.userIdPlaceholder": "شناسه کاربر [12,34,...]",
  "files.versionSummary": "نسخه {version} · {size} بایت",
  "files.versions": "نسخه‌ها",
  "settings.checking": "در حال بررسی…",
  "settings.cloudRelay": "نقطه پایانی رله ابری",
  "settings.cloudRelaySaved": "نقطه پایانی رله ابری ذخیره شد. برای اعمال، برنامه را مجدداً راه‌اندازی کنید.",
  "settings.cloudServiceNote": "ONYX برای احراز هویت و داده‌ها از سرویس ابری مدیریت‌شده خود استفاده می‌کند.",
  "settings.desktopConnectionNote": "اتصال مورد استفاده این برنامه دسکتاپ پرسنل را بررسی کنید.",
  "settings.legalHoldMissingConcurrencyEpochs": "دوره‌های هم‌زمانی در این نمای داده وجود ندارند. پیش از آزادسازی نگهداشت، تازه‌سازی کنید.",
  "settings.localDb": "پایگاه‌داده محلی‌محور",
  "settings.lookupPolicyById": "جست‌وجو بر اساس شناسه سیاست (UUID)",
  "settings.mobileAccessEnforcementDisabled": "پیکربندی ذخیره شده است، اما اعمال محدودیت ورود موبایل غیرفعال است. مقدار client_type که از سوی کلاینت ارسال می‌شود قابل جعل است و مبنای قابل‌اعتماد برای مجوزدهی نیست. تا زمان پیاده‌سازی هویت کلاینت قابل‌تأیید از سمت سرور یا attestation، برای محدود کردن ورود به این تنظیم تکیه نکنید.",
  "settings.mobileAccessPolicyDescription": "کلاس‌های کاربری موردنظر برای دسترسی موبایل را تنظیم کنید. سیاست ذخیره می‌شود؛ وضعیت اعمال آن در پایین جداگانه نمایش داده می‌شود.",
  "settings.mobileAccessPolicyScope": "این سیاست مبتنی بر کلاس، پس از احراز هویت برای قابلیت‌های محافظت‌شده مشخص‌شده اعمال می‌شود. ورود را مسدود نمی‌کند و دستگاه موبایل را تشخیص نمی‌دهد؛ client_type مبنای مجوزدهی نیست.",
  "settings.noLegalHoldFound": "برای این شناسه هیچ نگهداشت قانونی پیدا نشد.",
  "settings.organizationPolicyDescription": "سیاست سازمان: دسترس‌پذیری قابلیت‌ها، محدودیت‌ها، نگهداری و نگهداری قانونی.",
  "settings.p2pSync": "همگام‌سازی همتا‌به‌همتا",
  "settings.policyMissingConcurrencyEpochs": "دوره‌های هم‌زمانی در این نمای داده وجود ندارند. پیش از تغییر این سیاست، تازه‌سازی کنید.",
  "settings.publishDraft": "انتشار پیش‌نویس",
  "settings.release": "انتشار",
  "settings.retirePolicy": "بازنشسته‌سازی سیاست",
  "settings.retryApplicationSafely": "اعمال را با اطمینان دوباره تلاش کنید",
  "settings.retryCreationSafely": "ایجاد را با اطمینان دوباره تلاش کنید",
  "settings.returnToDashboard": "بازگشت به داشبورد",
  "settings.signingOut": "در حال خروج…",
  "settings.title": "تنظیمات",
  "language.note": "زبان رابط کاربری. بلافاصله اعمال می‌شود و در این دستگاه به خاطر سپرده می‌شود.",
  "language.title": "زبان"
} as Record<string, string>;
export const dictionaries = { en, fa } as const;
